import React, { useState, useEffect } from "react";
import {
  Dialog,
  Box,
  Slide,
  makeStyles,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TableBody,
  Table,
  TableRow,
  TableHead,
  TableCell,
  Button,
  Snackbar,
  IconButton,
  Divider,
  TableContainer,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import axios from "axios";
import { AccountVerificationAPI, baseUrl, GetAllEntityAPI } from "../../config/api";
import { useSelector } from "react-redux";
import MuiAlert from "@material-ui/lab/Alert";
import { Typography } from "@mui/material";
import { toast } from "react-toastify"
import { normalizeShippingRowsFromApi } from "../../utils/accountShippingAddress";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  headerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
  },
  headerTitle: {
    margin: 0,
    fontWeight: 500,
    fontSize: 18,
    lineHeight: 1.2,
  },
  headerSubtitle: {
    margin: 0,
    opacity: 0.85,
    fontSize: 13,
  },
  sectionTitle: {
    fontWeight: 700,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  tableContainer: {
    maxHeight: 260,
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: 8,
  },
  docCard: {
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: 10,
    overflow: "hidden",
    background: "#fff",
  },
  docTitle: {
    fontWeight: 600,
    fontSize: 13,
    padding: theme.spacing(1),
    borderBottom: "1px solid rgba(0,0,0,0.06)",
    background: "rgba(0,0,0,0.02)",
  },
  docImg: {
    width: "100%",
    height: 180,
    objectFit: "contain",
    display: "block",
    background: "rgba(0,0,0,0.02)",
  },
  stickyActions: {
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    background: "#fff",
    borderTop: "1px solid rgba(0,0,0,0.08)",
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(1),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function getErrorMessage(err) {
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim() !== "") return data;
  if (typeof data?.error === "string" && data.error.trim() !== "") return data.error;
  if (typeof data?.message === "string" && data.message.trim() !== "") return data.message;
  if (typeof err?.message === "string" && err.message.trim() !== "") return err.message;
  return "Something went wrong. Please contact admin.";
}

function normalizeEntityOption(entity) {
  const rawId = entity?._id;
  const entityId =
    typeof rawId === "object" && rawId != null ? rawId.$oid || "" : rawId || "";

  return {
    entityId: String(entityId),
    entityLabel: entity?.name || entity?.title || "",
  };
}

function normalizeEntity(value) {
  if (!value) return null;
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    return value?._id || value?.id || value?.value || value?.name || null;
  }
  return null;
}

export default function AccountVerificationView(props) {
  const { open, close, item } = props;
  console.log(item, "this is single item")
  const [accountCode, setAccountCode] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertObject, setAlertObject] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [entityType, setEntityType] = useState(null);
  const [entities, setEntities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const authToken = useSelector((state) => state.userReducer.authToken);
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const classes = useStyles();

  useEffect(() => {
    _getEntities();
  }, []);

  async function _getEntities() {
    try {
      const res = await axios.get(GetAllEntityAPI(), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log(res.data, "this is entity list");
      const entityList = Array.isArray(res.data?.entity)
        ? res.data.entity
        : Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.entities)
            ? res.data.entities
            : [];
      setEntities(
        entityList
          .map(normalizeEntityOption)
          .filter((entity) => entity.entityId && entity.entityLabel)
      );
    } catch (err) {
      setEntities([]);
    }
  }

  if (!item) {
    return null;
  }

  let {
    accountCode: itemAccountCode,
    name,
    contact,
    gstNumber,
    panNumber,
    adharNumber,
    address,
    city,
    state,
    pin,
    landline,
    mobile,
    whatsappNumber,
    email,
    shippingAddress,
    users = [],
    _id,
    entity,
    accountLogo,
    gstCard,
    visitingCard,
    panCard,
    adharCard,
  } = item;

  const shippingRows = Array.isArray(shippingAddress?.allAddress)
    ? normalizeShippingRowsFromApi(shippingAddress.allAddress)
    : normalizeShippingRowsFromApi(shippingAddress);

  const resolveAccountId = (currentItem) =>
    currentItem?.accountId || currentItem?.account?._id || currentItem?._id || null;

  async function _onReject() {
    if (isSubmitting) return;
    try {
      setIsSubmitting(true);
      const effectiveEntity =
        normalizeEntity(entityType) || normalizeEntity(userInfo?.entity) || null;
      const accountId = resolveAccountId(item);
      console.log("AccountVerification ids", {
        accountId,
        entityType,
        userInfoEntity: userInfo?.entity,
        effectiveEntity,
        itemId: item?._id,
        itemEntity: item?.entity,
      });
      let body = {
        accountCode,
        users,
        entity: effectiveEntity,
        adminVerification: false,
      };
      let res = await axios.patch(AccountVerificationAPI(accountId), body, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success('Successfully Rejected!', {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      close();
    } catch (err) {
      // console.log(err);
      // toast.error(("Something went wrong, Please Contact Admin"), {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      setOpenSnackbar(true);
      const msg =
        err?.response?.data?.details ??
        err?.response?.data?.error ??
        err?.response?.data?.message ??
        (typeof err?.response?.data === "string" ? err.response.data : null) ??
        (typeof err?.response?.data === "object"
          ? JSON.stringify(err.response.data)
          : null) ??
        err?.message ??
        "Request failed";
      setAlertObject({ status: "error", message: msg });
    } finally {
      setIsSubmitting(false);
    }
  }
  async function _onSave() {
    if (isSubmitting) return;
    try {
      setIsSubmitting(true);
      const effectiveEntity =
        normalizeEntity(entityType) || normalizeEntity(userInfo?.entity) || null;
      const accountId = resolveAccountId(item);
      console.log("AccountVerification ids", {
        accountId,
        entityType,
        userInfoEntity: userInfo?.entity,
        effectiveEntity,
        itemId: item?._id,
        itemEntity: item?.entity,
      });
      let body = {
        accountCode,
        users,
        entity: effectiveEntity,
        adminVerification: true,
      };
      console.log("onsaveitem", _id, item, entity)
      let res = await axios.patch(AccountVerificationAPI(accountId), body, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      close();
    } catch (err) {
      // console.log(err.response.data);
      // toast.error(("Something went wrong, Please Contact Admin"), {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      setOpenSnackbar(true);
      setAlertObject({ status: "error", message: getErrorMessage(err) });
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box className={classes.headerBar}>
                <Box>
                  <h4 className={`${classes.cardTitleWhite} ${classes.headerTitle}`}>
                    Account Verification
                  </h4>
                  <p className={`${classes.cardCategoryWhite} ${classes.headerSubtitle}`}>
                    {name || "—"} {_id ? `• ${_id}` : ""}
                  </p>
                </Box>
                <IconButton
                  aria-label="Close"
                  onClick={close}
                  style={{ color: "#fff" }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Account Code*"
                    id="accountCode"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: accountCode,
                      onChange: (event) => setAccountCode(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Name"
                    id="name"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: name,
                      disabled: true,
                    }}
                  />
                </GridItem>

                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Landline"
                    id="landline"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: landline,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Mobile"
                    id="mobile"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: mobile,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="WhatsApp Number"
                    id="whatsappNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: whatsappNumber,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Email"
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: email,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="GST Number"
                    id="gstNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: gstNumber,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="PAN Number"
                    id="panNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: panNumber,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Aadhaar Number"
                    id="adharNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: adharNumber,
                      disabled: true,
                    }}
                  />
                </GridItem>

                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Address"
                    id="address"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: address,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="City"
                    id="city"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: city,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="State"
                    id="state"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: state,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="PIN Code"
                    id="pin"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: pin,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12} style={{ marginTop: 10 }}>
                  <Typography className={classes.sectionTitle}>
                    Shipping Addresses
                  </Typography>
                  <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader aria-label="shipping address table" size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Full Name</TableCell>
                          <TableCell>Address</TableCell>
                          <TableCell>State</TableCell>
                          <TableCell>City</TableCell>
                          <TableCell>PIN</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(shippingRows || []).map((r, idx) => (
                          <TableRow key={`ship-${idx}`}>
                            <TableCell>{r.fullname || "—"}</TableCell>
                            <TableCell>{r.address || "—"}</TableCell>
                            <TableCell>{r.stateAddress || "—"}</TableCell>
                            <TableCell>{r.city || "—"}</TableCell>
                            <TableCell>{r.pincode || "—"}</TableCell>
                          </TableRow>
                        ))}
                        {(!shippingRows || shippingRows.length === 0) && (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              —
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} style={{ display: "flex", alignItems: "center" }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Entity Type*
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={entityType}
                      label="Type"
                      onChange={(e) => {
                        e.preventDefault();
                        setEntityType(e.target.value);
                      }}
                    >
                      {entities.map((entity) => {
                        const { entityId, entityLabel } = entity;
                        return (
                          <MenuItem key={entityId} value={entityId}>
                            {entityLabel}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12}>
                  <Divider style={{ marginTop: 16, marginBottom: 12 }} />
                  <Typography className={classes.sectionTitle}>
                    Documents
                  </Typography>
                  <GridContainer>
                    {accountLogo ? (
                      <GridItem xs={12} sm={6} md={3}>
                        <div className={classes.docCard}>
                          <div className={classes.docTitle}>Account Logo</div>
                          <img
                            alt="Account Logo"
                            src={`${baseUrl}${accountLogo}`}
                            className={classes.docImg}
                          />
                        </div>
                      </GridItem>
                    ) : null}
                    {visitingCard ? (
                      <GridItem xs={12} sm={6} md={3}>
                        <div className={classes.docCard}>
                          <div className={classes.docTitle}>Visiting Card</div>
                          <img
                            alt="Visiting Card"
                            src={`${baseUrl}${visitingCard}`}
                            className={classes.docImg}
                          />
                        </div>
                      </GridItem>
                    ) : null}
                    {panCard ? (
                      <GridItem xs={12} sm={6} md={3}>
                        <div className={classes.docCard}>
                          <div className={classes.docTitle}>PAN Card</div>
                          <img
                            alt="PAN Card"
                            src={`${baseUrl}${panCard}`}
                            className={classes.docImg}
                          />
                        </div>
                      </GridItem>
                    ) : null}
                    {adharCard ? (
                      <GridItem xs={12} sm={6} md={3}>
                        <div className={classes.docCard}>
                          <div className={classes.docTitle}>Aadhaar Card</div>
                          <img
                            alt="Aadhaar Card"
                            src={`${baseUrl}${adharCard}`}
                            className={classes.docImg}
                          />
                        </div>
                      </GridItem>
                    ) : null}
                    {gstCard ? (
                      <GridItem xs={12} sm={6} md={3}>
                        <div className={classes.docCard}>
                          <div className={classes.docTitle}>GST Card</div>
                          <img
                            alt="GST Card"
                            src={`${baseUrl}${gstCard}`}
                            className={classes.docImg}
                          />
                        </div>
                      </GridItem>
                    ) : null}
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} style={{ marginTop: 15 }}>
                  <Typography className={classes.sectionTitle}>
                    Users
                  </Typography>
                  <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader aria-label="users table" size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>User Name</TableCell>
                          <TableCell>Phone</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Address</TableCell>
                          <TableCell>Role</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(users || []).map((user, index) => (
                          <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                            <TableCell>{user?.name || "—"}</TableCell>
                            <TableCell>{user?.mobile || "—"}</TableCell>
                            <TableCell>{user?.email || "—"}</TableCell>
                            <TableCell>{user?.address || "—"}</TableCell>
                            <TableCell>{user?.role || "—"}</TableCell>
                          </TableRow>
                        ))}
                        {(!users || users.length === 0) && (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              —
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </GridItem>
              </GridContainer>
              <div className={classes.stickyActions}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => _onReject()}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Working..." : "Reject"}
                </Button>
                <Box style={{ flex: 1 }} />
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  onClick={() => {
                    if (accountCode === "" || entityType === null) {
                      toast.error("Please fill the required fields", {
                        position: "top-center",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                      return;
                    }

                    _onSave();
                  }}
                >
                  {isSubmitting ? "Accepting..." : "Accept"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {alertObject ? (
        <Snackbar
          open={openSnackbar}
          autoHideDuration={2000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity={alertObject.status}>
            {alertObject.message}
          </Alert>
        </Snackbar>
      ) : null}
    </Dialog>
  );
}
